var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("JobsOccupationsResume", {
        attrs: {
          jobs: _vm.value.perimeter_jobs,
          occupations: _vm.value.perimeter_occupations,
          displayWishes: false,
          jobColors: _vm.jobColors,
          occupationColors: _vm.occupationColors,
        },
      }),
      _vm._v(" "),
      !_vm.loading && !_vm.resource.occupations_skills
        ? _c("div", { staticClass: "not-data-table vs-table--not-data" }, [
            _vm._v("Il n'y a aucun savoir-faire à évaluer"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "vs-row",
        [
          _c(
            "vs-col",
            {
              staticClass: "mt-8",
              attrs: {
                "vs-w": "4",
                "vs-type": "flex",
                "vs-justify": "flex-start",
                "vs-align": "center",
              },
            },
            [
              _c(
                "vs-checkbox",
                {
                  attrs: { name: "checkboxDeletedOccSkills" },
                  model: {
                    value: _vm.showDeletedOccSkills,
                    callback: function ($$v) {
                      _vm.showDeletedOccSkills = $$v
                    },
                    expression: "showDeletedOccSkills",
                  },
                },
                [
                  _vm._v(
                    "\n                    Affichage des savoir-faire supprimés\n                "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "vs-col",
            { attrs: { "vs-w": "8" } },
            [
              _c(
                "vs-row",
                { staticClass: "mt-8" },
                [
                  _c(
                    "vs-col",
                    { attrs: { "vs-w": "4" } },
                    [
                      _vm.hasPersonals
                        ? _c(
                            "vs-checkbox",
                            {
                              attrs: { name: "checkboxComparePortalPersonal" },
                              model: {
                                value: _vm.comparePortalPersonal,
                                callback: function ($$v) {
                                  _vm.comparePortalPersonal = $$v
                                },
                                expression: "comparePortalPersonal",
                              },
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "other_level vs-component con-vs-radio vs-radio-primary",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "other_level_type_0" },
                                    [_vm._v("|")]
                                  ),
                                ]
                              ),
                              _vm._v(
                                "\n                            Auto-évaluation Portail " +
                                  _vm._s(
                                    _vm.hasPersonals
                                      ? `du ${this.formatDate(
                                          _vm.resource.personals[0].rating_date
                                        )}`
                                      : ""
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "vs-col",
                    { attrs: { "vs-w": "6" } },
                    [
                      _vm.hasExternals
                        ? _c(
                            "vs-checkbox",
                            {
                              attrs: { name: "checkboxComparePortalExternal" },
                              model: {
                                value: _vm.comparePortalExternal,
                                callback: function ($$v) {
                                  _vm.comparePortalExternal = $$v
                                },
                                expression: "comparePortalExternal",
                              },
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "other_level vs-component con-vs-radio vs-radio-primary",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "other_level_type_1" },
                                    [_vm._v("|")]
                                  ),
                                ]
                              ),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.resource.externals[0].eval_type) +
                                  " " +
                                  _vm._s(
                                    `du ${this.formatDate(
                                      _vm.resource.externals[0].rating_date
                                    )}`
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasTwoExternals
                        ? _c(
                            "vs-checkbox",
                            {
                              attrs: {
                                name: "checkboxComparePortalSecondExternal",
                              },
                              model: {
                                value: _vm.comparePortalSecondExternal,
                                callback: function ($$v) {
                                  _vm.comparePortalSecondExternal = $$v
                                },
                                expression: "comparePortalSecondExternal",
                              },
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "other_level vs-component con-vs-radio vs-radio-primary",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "other_level_type_2" },
                                    [_vm._v("|")]
                                  ),
                                ]
                              ),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.resource.externals[1].eval_type) +
                                  " " +
                                  _vm._s(
                                    `du ${this.formatDate(
                                      _vm.resource.externals[1].rating_date
                                    )}`
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.resource.occupations_skills || _vm.loading
        ? _c("Rating-Manager", {
            attrs: {
              name: "occupation-skills",
              "type-form": _vm.typeForm,
              "show-deleted": _vm.showDeletedOccSkills,
              col1: {
                label: "Savoir-faire",
                value: "title",
                title: "description",
                chip: true,
                chipColor: "job_color",
              },
              col2: {
                label: "Expériences",
                value: "job_name",
                title: "job_description",
              },
              col3: { label: "Services/Filières", value: "service_name" },
              loading: _vm.loading,
              "skill-review": _vm.skillReview,
            },
            model: {
              value: _vm.resource.occupations_skills,
              callback: function ($$v) {
                _vm.$set(_vm.resource, "occupations_skills", $$v)
              },
              expression: "resource.occupations_skills",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }